<template>
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.9226 2.44922L3.17383 11.417"
      stroke="#868D9C"
      stroke-width="2"
      stroke-linecap="round"
    />
    <circle cx="7" cy="7" r="6" stroke="#868D9C" stroke-width="2" />
  </svg>
</template>
